import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    agente: { required },
    ramal: { required },
    password: { required },
  },
}

export const validateComputed = {
  agenteErrors() {
    const errors = []
    if (!this.$v.form.agente.$dirty) return errors
    !this.$v.form.agente.required && errors.push('Campo obrigatório.')
    return errors
  },

  ramalErrors() {
    const errors = []
    if (!this.$v.form.ramal.$dirty) return errors
    !this.$v.form.ramal.required && errors.push('Campo obrigatório.')
    return errors
  },

  passwordErrors() {
    const errors = []
    if (!this.$v.form.password.$dirty) return errors
    !this.$v.form.password.required && errors.push('Campo obrigatório.')
    return errors
  },
}
